import Heading from "src/Pages/Company/Dashboard/components/Heading";

const MenuConfiguration = () => <Heading />;

export default MenuConfiguration;
